<template>
	<div class="LfHonorStyleTow">
		<div class="Image" :style="'background-color: '+bac">
			<div class="ImageDiv"> 
			<img :src="Img"/>
			</div>
		</div>
		<div class="nameLabel">
			<div class="nameLabelText">{{name}}</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'LfHonorStyleTow',
		props:{
			Img:{
				default:""
			},
			name:{
				default:""
			},
			bac:{
				default:"#F4F4F4"
			}
		}
	}
</script>

<style>
	.LfHonorStyleTow {
		width: 19.84375rem;
		height: 16.5625rem;
		display: flex;
		flex-direction: column;
	}
	
	.LfHonorStyleTow .Image{
		width: 100%;
		height: 12rem;
		border: #F4F4F4 1px solid;
	}
	
	.LfHonorStyleTow .Image .ImageDiv{
		width: 9rem;
		height: 9rem;
		margin-top: 0.625rem;
		margin: 1.525rem auto;
	}
	
	.LfHonorStyleTow .Image .ImageDiv img{
		width: 100%;
		height: 100%;
	}
	
	.LfHonorStyleTow .nameLabel{
		margin: auto;
	}
	
	.LfHonorStyleTow .nameLabel .nameLabelText{
		font-size: 1.025rem;
	}
	
</style>
